import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, TableData } from "../../../../../components";
import { errorAlert } from "../../../../../helpers/alerts";
import { createCredTAESegmentService, deleteCredTAESegmentService } from "services/admin/providerService";
import { Grid } from "@mui/material";
import { setSegments as setCredTaeSegments } from "redux/slices/admin/providerSlice";
import { setSegments } from "redux/slices/admin/segmentSlice";
import { getSegmentsByOperatorService } from "services/admin/segmentServices";

const CredTAESegmentsScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    providerCredSelected,
    currentOperator,
    segments: credTaeSegments,
  } = useSelector((store) => store.providers);
  const { segments } = useSelector((store) => store.segments);

  useEffect(() => {
    getSegmentsByOperatorService(currentOperator.id)
      .then(response => dispatch(setSegments(response)))
      .catch(error => errorAlert(error))
    // eslint-disable-next-line
  }, []);

  const handlerCheck = async ({ id }, currentValue) => {
    (currentValue ?
      deleteCredTAESegmentService(providerCredSelected.id, currentOperator.id, id) :
      createCredTAESegmentService(providerCredSelected.id, currentOperator.id, id)
    ).then((result) => {
      dispatch(setCredTaeSegments(result));
    }).catch(error => errorAlert(error))
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate('..')} />
        </div>
        <div className="container-title">
          <div className="title">Productos - Segmentos</div>
          <div className="subtitle">{providerCredSelected.name_connector}</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <TableData
        dataRows={segments.map((item) => {
          const find = credTaeSegments.find(({ idSegment }) => idSegment.id === item.id);
          return { ...item, state: find ? true : false };
        })}
        dataTitle={["Logo", "Nombre", "Estado"]}
        formatter={({ name, state, fd }) => [
          { type: "img", value: `/v3/file/${fd}/` },
          name,
          { name: "state", type: "boolean", value: state },
        ]}
        onChecked={handlerCheck}
      />
    </>
  );
};

export default CredTAESegmentsScreen;
